





















































































































import {
  Component,
  Inject,
  Mixins,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";

import { ITicketMessage } from "@/models/tickets";
import { DataModules } from "@/store/modules/data";

import FileProvider from "@/components/app/global/files/filesProvider.vue";

import {
  ITicketFeedProvider,
  ITicketFeedProviderMethods,
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";

import LoggedUserMixin from "@/mixins/loggedUserMixin";
import RequestPromises from "@/mixins/requestPromises";
import { mapState } from "vuex";
import { IState } from "@/store";
import { NewLine } from "@/store/modules/ui";
import Context from "@/mixins/context";

@Component({
  components: {
    FileProvider,
    "file-upload-button": () =>
      import("@/components/app/global/files/fileUploadButton.vue"),
    "file-list": () => import("@/components/app/global/files/fileList.vue")
  },
  computed: {
    ...mapState({
      newLine: (state: IState) => state.ui.support.newLine,
      submitWithShortcut: (state: IState) => state.ui.support.submitWithShortcut
    })
  }
})
export default class TicketMessageForm extends Mixins(
  RequestPromises,
  LoggedUserMixin,
  Context
) {
  public $refs!: {
    textarea: Vue;
    filesProvider: Vue;
  };
  // Inject
  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;
  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: () => ITicketProviderMethods;
  @Inject({ from: "ticketFeedProviderData" })
  public readonly $ticketFeedData!: () => ITicketFeedProvider;
  @Inject({ from: "ticketFeedProviderMethods" })
  public readonly $ticketFeedMethods!: ITicketFeedProviderMethods;

  @Prop({ default: false })
  public disabled!: boolean;

  public newLine!: NewLine;
  public submitWithShortcut!: boolean;
  public message = "";
  public isProcessing = false;
  public isPrivate = false;

  public get ticketData() {
    return this.$ticketData();
  }
  public get ticketFeedData() {
    return this.$ticketFeedData();
  }

  public get validForm() {
    return !this.$_.isEmpty(this.$_.trim(this.message));
  }

  public isDisabled($filesData) {
    return (
      ($filesData.files.length === 0 && !this.validForm) ||
      this.disabled ||
      !$filesData.hasValidAttachments
    );
  }

  @Watch("isPrivate")
  public focusTextarea() {
    // @ts-ignore
    this.$nextTick(() => this.$refs.textarea.$el.focus());
  }

  public onEnter($event) {
    if (this.newLine === NewLine.SHIFT_AND_ENTER) {
      $event.preventDefault();
      if (this.submitWithShortcut) this.createMessage();
    }
  }

  public onShiftAndEnter($event) {
    if (this.newLine === NewLine.ENTER) {
      $event.preventDefault();
      if (this.submitWithShortcut) this.createMessage();
    }
  }

  public async createMessage() {
    const filesProvider = this.$refs.filesProvider as any;

    if (
      this.isProcessing ||
      (filesProvider.files.length === 0 && !this.validForm) ||
      !filesProvider.hasValidAttachments
    )
      return;

    this.$emit("switchToAll");
    this.isProcessing = true;

    try {
      await filesProvider.uploadFiles();

      const newAttachments = this.$_.map(
        this.$_.get(this.$refs.filesProvider, "attachments", []),
        attachment => {
          return this.$_.pick(attachment, ["id", "hash"]);
        }
      );

      const message = await this.$store.dispatch(
        `data/${DataModules.TICKETS}/reply`,
        {
          id: this.ticketData.ticket.id,
          data: this.$_.merge(
            {
              body: this.$_.trim(this.message),
              is_private: this.isPrivate
            },
            newAttachments.length ? { files: newAttachments } : {}
          ),
          vm: this
        }
      );

      this.$ticketFeedMethods.addMessage(message);
      this.message = "";
      filesProvider.clearFileUploader();
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
      this.focusTextarea();
    }
  }

  public get lastMessage() {
    return this.$_.first(
      this.$_.orderBy(this.ticketFeedData.messages, "id", "desc")
    ) as ITicketMessage;
  }

  public get isLastMessageFromTheSameUser(): boolean {
    return (
      this.lastMessage.user_id === this.loggedUser.id ||
      this.lastMessage.client_id === this.loggedUser.id
    );
  }

  public editMessage() {
    if (
      !this.$_.isEmpty(this.message) ||
      this.$_.isEmpty(this.lastMessage) ||
      !this.isLastMessageFromTheSameUser
    ) {
      return;
    }
    const prevFocusedEl = this.$_.get(this.$refs, "textarea.$el", null);
    this.$bus.$emit(`ticket/edit-message-${this.lastMessage.id}`, {
      message: this.lastMessage,
      prevFocusedEl
    });
  }

  public openPreferencesModal() {
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/tickets/supportPreferencesModal.vue"),
        width: 480,
        canCancel: ["escape", "button", "x"],
        events: {
          close: this.focusTextarea
        }
      }
    });
  }
}
